export const getLayerSpacing = buttonWidth => buttonWidth * 0.15